import { Box, DataTableAction, DataTableLabel, Flex, Link, Text, Tooltip } from '@optiaxiom/react';
import { IconLock } from '@optimizely/axiom-icons';

import { UnifiedAgent } from '@frontend/types/agent';

type NameCellProps = {
  agent: UnifiedAgent;
  onClick: (agent: UnifiedAgent) => void;
};

export const NameCell = ({ agent, onClick }: NameCellProps) => {
  return (
    <Flex flexDirection="column" gap="4" alignItems="start">
      <DataTableLabel asChild>
        <DataTableAction overflow="hidden" primary>
          <Link appearance="subtle" href="data:," onClick={() => onClick(agent)}>
            <Flex gap="6" flexDirection="row" alignItems="center">
              <Text>{agent.name}</Text>
              {agent.is_system_agent && agent.is_installed && (
                <Tooltip content="Optimizely Managed Agent">
                  <Box>
                    <IconLock aria-label="Optimizely Managed Agent lock icon" size="18" />
                  </Box>
                </Tooltip>
              )}
            </Flex>
          </Link>
        </DataTableAction>
      </DataTableLabel>
      <Text fontSize="sm" color="fg.tertiary">
        @{agent.agent_id}
      </Text>
    </Flex>
  );
};
